import { z } from 'zod'
import {
  ErpCustomerDiscountCode,
  ErpCustomerDiscountCodeSchema,
} from '../api/discounts'
import { StrapiID, StrapiIdSchema } from './common'
import { Requirements } from './requirements'

export type ApplicationMethod = 'ondemand'

export type ItemTarget = 'first' | 'last'

type BaseDiscountRule = {
  id: StrapiID
  name: string
  description?: string
  items?: ItemTarget
  requirements: Requirements
}

export type GroupRule = BaseDiscountRule & {
  application_method: 'ondemand'
  groups: string[]
}

export type PromotionsResult = Record<string, PromotionItem>

export type Rule = GroupRule

// Zod schemas
export const ItemTargetSchema = z.enum(['first', 'last'])

export const RequirementCheckSchema = z.enum(['any', 'none'])

export const RequirementConfigSchema = z.object({
  config: z.object({
    variable: z.string(),
    values: z.array(z.string()),
  }),
  check: RequirementCheckSchema.optional(),
})

export const RequirementsSchema = z.array(RequirementConfigSchema)

export const BaseDiscountRuleSchema = z.object({
  id: StrapiIdSchema,
  name: z.string(),
  description: z.string().nullish(),
  items: ItemTargetSchema.nullish(),
  requires: RequirementsSchema.nullish(),
})

export const GroupRuleSchema = BaseDiscountRuleSchema.extend({
  application_method: z.literal('ondemand'),
  groups: z.array(z.string()),
})

export const PromotionItemSchema = ErpCustomerDiscountCodeSchema.extend({
  rule: GroupRuleSchema,
  items: z.array(z.number()),
})

export type PromotionItem = z.infer<typeof PromotionItemSchema>

export const PromotionsResultSchema = z.record(z.string(), PromotionItemSchema)
